module.exports = __webpack_public_path__ + "img/17953221.5c7eaa4f.png";